// extracted by mini-css-extract-plugin
export default {"logoImage":"Masinac_logoImage__BLbqg"};